import { JSX } from "react";
import { Link } from "react-router-dom";

import { Distributor } from "@/@types/general";
import { ROUTES } from "@/config/routes.ts";
import { cn } from "@/utils/cn.ts";

const DistributorCard = ({ distributor }: { distributor: Distributor }): JSX.Element => {
  return (
    <Link
      to={ROUTES.MAIN.DISTRIBUTOR.replace(":id", distributor.id.toString())}
      className={cn(
        "group relative flex aspect-[560/160] max-h-[10rem] w-full items-center justify-center overflow-hidden rounded-3xl transition-colors max-lg:rounded-xl max-sm:aspect-[160/80]",
      )}
    >
      <div className="group/hover:bg-surface-container-high absolute bottom-0  left-0 right-0 top-0 bg-surface-bright opacity-40 group-hover:opacity-80 max-md:opacity-80"></div>
      <div
        className={
          "relative h-full w-full p-4 opacity-50 transition-all  group-hover:opacity-100 group-hover:grayscale-0 max-md:opacity-100 max-sm:p-2 max-sm:py-5 md:p-6"
        }
      >
        <img src={distributor.icon_svg} alt={distributor.name} className="m-auto h-full w-auto" />
      </div>
    </Link>
  );
};

export default DistributorCard;
